import * as tslib_1 from "tslib";
import env from '../env';
import { formApi, listApi } from '@cloudpivot/api';
import { utils } from '@cloudpivot/common';
import Store from '@/store/index';
export class DefaultFileService {
    constructor() {
        this.interval = null;
    }
    getListUploadUrl() {
        return `${env.apiHost}/api/runtime/query/upload_file2`;
    }
    getUploadUrl() {
        return `${env.apiHost}/api/aliyun/upload`;
    }
    getDownloadUrl(file) {
        const url = `${env.apiHost}/api/aliyun/download?refId=${file.refId}`;
        const token = window.externalLinkToken || localStorage.getItem('token');
        if (!token) {
            return url;
        }
        return `${url}&T=${token}`;
    }
    getDownloadPrintUrl(file) {
        if (!file) {
            return '';
        }
        const url = env.apiHost + `/api/aliyun/print/download?refId=${file.refId}&fileName=${file.name}`;
        const token = localStorage.getItem('token');
        if (!token) {
            return url;
        }
        return url + `&T=${token}`;
    }
    getDownloadUrlByRefId(refId) {
        if (!refId) {
            return '';
        }
        const url = env.apiHost + `/api/aliyun/download?refId=${refId}`;
        const token = window.externalLinkToken || localStorage.getItem("token");
        if (!token) {
            return url;
        }
        return url + `&T=${token}`;
    }
    getPreviewUrl(file) {
        const sysConfig = Store.state.config;
        let url = "";
        // 判断用户是否开启了附件预览服务
        if (sysConfig && sysConfig.openIDocView) {
            const downloadUrl = this.getDownloadUrl(file);
            url = `${sysConfig.idocvServiceUrl}/view/url?url=${encodeURIComponent(downloadUrl)}&name=${encodeURIComponent(file.name)}`;
        }
        return url;
    }
    getIsOpenPreview() {
        const sysConfig = Store.state.config;
        return sysConfig.openIDocView ? true : false;
    }
    getHeaders() {
        const token = window.externalLinkToken || localStorage.getItem('token');
        if (token) {
            return { Authorization: `Bearer ${token}` };
        }
        return {};
    }
    download(file) {
        const url = this.getDownloadUrl(file);
        window.open(url);
    }
    downloadBatch(files) {
        if (files.length === 0) {
            return;
        }
        const refIds = files.map(f => f.refId).join(',');
        let url = `${env.apiHost}/api/aliyun/download_multi?multiVO=${refIds}`;
        const token = window.externalLinkToken || localStorage.getItem('token');
        if (token) {
            url += `&access_token=${token}`;
        }
        window.open(url);
        // utils.downloadFileByPost(url, {
        //   refIds
        // });
    }
    preview() { }
    upFile(file) {
        return Promise.resolve();
    }
    getSheetDetail(params) {
        return formApi.importData(params);
    }
    exportSheet(params, e) {
        const name = params.name + utils.DateHandle.dateFormat(new Date(), 'YYYYMMDDHHmmss');
        // 
        formApi.exportData(params).then((res) => {
            if (res.errcode !== 0) {
                e.$message.error(e.$t("cloudpivot.list.pc.ExportFailure"));
            }
            else {
                const loading = e.$message.loading(e.$t("cloudpivot.list.pc.ExportLoading"), 0);
                this.interval = setInterval(() => {
                    this.getExportProgress(res.data.id, e);
                }, 2000);
            }
            // if ((res.errcode && res.errcode !== 0) || res.byteLength < 100) {
            //
            // } else {
            //
            //   // const blob = new Blob([res], { type: 'application/vnd.ms-excel' });
            //   // const fileName = `${params.subSchemaCode}.xlsx`;
            //   // this.downloadFile(blob, fileName);
            //   if (res.errcode === 0) {
            //     this.exportErrorResult(res.data, name);
            //   }
            // }
        });
    }
    getExportProgress(id, e) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield listApi.getExportingProgress({ id: id });
            if (res.errcode === 0) {
                if (res.data.exportResultStatus) {
                    clearInterval(this.interval);
                    this.downLoadExportFile(id, e);
                }
            }
            else {
                clearInterval(this.interval);
                e.$message.error(res.errmsg);
            }
        });
    }
    downLoadExportFile(id, e) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield listApi.getExportFile({ id: id });
            const blob = new Blob([res], { type: 'application/vnd.ms-excel;charset=UTF-8' });
            const date = new Date();
            const mounth = date.getMonth() > 8 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
            const days = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
            const hours = date.getHours() > 9 ? date.getHours() : `0${date.getHours()}`;
            const minutes = date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`;
            const seconds = date.getSeconds() > 9 ? date.getSeconds() : `0${date.getSeconds()}`;
            const stamp = `${date.getFullYear()}${mounth}${days}${hours}${minutes}${seconds}`;
            const fileName = `子表导出文件${stamp}.xlsx`;
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, fileName);
            }
            else {
                const a = document.createElement('a');
                const url = URL.createObjectURL(blob);
                a.download = fileName;
                a.href = url;
                a.click();
                URL.revokeObjectURL(url);
            }
            e.$message.destroy();
        });
    }
    /**
     * 文件下载方法
     */
    downloadFile(blob, fileName) {
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
        }
        else {
            const a = document.createElement('a');
            const url = URL.createObjectURL(blob);
            a.download = fileName;
            a.href = url;
            a.click();
            URL.revokeObjectURL(url);
        }
    }
    exportErrorResult(file, name) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield listApi.exportErrorResult(file);
            if ((res.errcode && res.errcode !== 0) || res.byteLength < 100) {
                // this.$message.error(this.$t('cloudpivot.list.pc.DownloadFailed'));
            }
            else {
                const blob = new Blob([res], { type: 'application/vnd.ms-excel' });
                const stamp = new Date().getMilliseconds();
                let fileName = '';
                if (name) {
                    fileName = `${name}.xlsx`;
                    //清除临时文件
                    listApi.deleteTemporaryFile({ fileName: file });
                }
                else {
                    fileName = `错误信息${stamp}.xlsx`;
                }
                this.downloadFile(blob, fileName);
            }
        });
    }
}
